import { http } from "@/utils/http";

/**
 * @desc 上传文件
 * @returns
 */
export const uploadFile = file => {
  const data = new FormData();
  data.append("file", file);
  return http.request(
    "post",
    "/v1/files",
    { data },
    {
      headers: {
        "Content-Type": "multipart/form-data",
        noCheckCode: true
      }
    }
  );
};
export const uploadFileIco = file => {
  const data = new FormData();
  data.append("file", file);
  return http.request(
    "post",
    "/v1/file/ico",
    { data },
    {
      headers: {
        "Content-Type": "multipart/form-data",
        noCheckCode: true
      }
    }
  );
};
const RAW_BASE_URL = import.meta.env.VITE_BASE_URL as string | undefined;
const BASE = (() => {
  const v = (RAW_BASE_URL || "").trim();
  if (!v) return "/api";
  if (v.startsWith("/v1")) return v.replace(/^\/v1(\b|\/)?/, "/api$1");
  return v;
})();
export const uploadUrl = BASE + "/v1/files";
export const uploadIcoUrl = BASE + "/v1/file/ico";

export async function getFileUrl(file, type = 1) {
  const res: any =
    type == 1 ? await uploadFile(file) : await uploadFileIco(file);
  return res.data;
}

// 批量
export async function getFilesUrl(files: File[] | any) {
  console.info(files);
  const data = [];
  for await (const file of files) {
    let curfile = file?.raw ? file?.raw : file;
    const res = await getFileUrl(curfile);
    console.info(res);
    data.push(res);
  }
  console.info(data);
  return data;
}

export default {
  getFileUrl
};
